<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-row>
            <b-col cols="12">
                <FormInput label="Nombre" name="descripcion" rules="required" v-model="tipo.descripcion" />
            </b-col>
            <b-col cols="12">
                <FormInput label="Resumen" name="resumen" rules="required" v-model="tipo.resumen" />
            </b-col>
            <b-col cols="12">
                <FormInput label="Stock" name="stock" type="number" rules="required" v-model="tipo.stock" />
            </b-col>
            <b-col cols="12" class="mt-2">
                <template v-if="eventos.length">
                    <div class="form-group">
                        <label for="eventos">Eventos</label>
                        <multiselect
                            v-model="tipo.eventos"
                            placeholder="Seleccione al menos un evento"
                            label="name"
                            track-by="id"
                            style="z-index: 999;"
                            :options="eventos"
                            :multiple="true"
                        />
                        <span 
                            v-if="errorEventos" 
                            class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold" 
                        >
                            {{ errorEventos }}
                        </span>
                    </div>
                </template>
                <div class="text-center" v-else>
                    <div class="spinner-border text-primary" role="status" />
                </div>
            </b-col>
            <b-col cols="12" v-if="url">
                <label for="imagen">Imagen</label>
                <Dropzone 
                    :url="url"
                    @success="imagenSubida"
                    @removed="imagenBorrada"
                />
                <span 
                    v-if="errorImagen" 
                    class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold" 
                >
                    {{ errorImagen }}
                </span>
                <template v-if="tipo.imagen_url">
                    <img :src="tipo.imagen_url" style="max-height: 300px" class="mt-2">
                    <div>
                        <Button class="mt-2" @click="imagenBorrada">Borrar</Button>
                    </div>
                </template>
            </b-col>
            <b-col cols="12" class="mt-2">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="renovacion" v-model="tipo.renovacion">
                    <label for="renovacion" class="custom-control-label pt-1">Renovación</label>
                </div>
            </b-col>
            <b-col cols="12">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="activo" v-model="tipo.activo">
                    <label for="activo" class="custom-control-label pt-1">Activado</label>
                </div>
            </b-col>
            <b-col cols="12">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="pago_plazos" v-model="tipo.activar_pago_plazos">
                    <label for="pago_plazos" class="custom-control-label pt-1">Pago a plazos</label>
                </div>
            </b-col>
            <b-col cols="12">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="venta_online_cerrada" v-model="tipo.venta_online_cerrada">
                    <label for="venta_online_cerrada" class="custom-control-label pt-1">No mostrar online</label>
                </div>
            </b-col>
            <b-col cols="12" class="mt-3">
                <Button type="submit" name="button">Continuar</Button>
            </b-col>
        </b-row>
    </ValidationObserver>
</template>

<script>
import Dropzone from '@/components/common/Dropzone';

export default {
    props: {
        tipo: { type: Object, required: true }
    },
    data() {
        return {
            eventos: [],
            errorImagen: '',
            errorEventos: '',
            url: this.config.API_BASE + '/upload/image?api_key=' + localStorage.getItem('token') + '&permisos=public'
        }
    },
    methods: {
        getEventos() {
            const data = {
                filters: {
                    to_select: true,
                    e: 'actuales'
                }
            };

            this.$store.dispatch(this.config.getVuexAlias('back.events.index'), data).then(res => {
                this.eventos = res.data;
            }).catch(error => {
                this.$toast.error(error.response?.data?.message);
            })
        },
        imagenSubida(file, response) {
            this.tipo.imagen = response;
            this.errorImagen = '';
        },
        imagenBorrada(file, error, xhr) {
            this.tipo.imagen = '';
            this.tipo.imagen_url = '';
            this.errorImagen = 'El campo imagen es obligatorio';
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();

            if (!this.tipo.imagen) {
                this.errorImagen = 'El campo imagen es obligatorio';
            }

            if (!this.tipo.eventos?.length) {
                this.errorEventos = 'El obligatorio seleccionar al menos un evento';
            }

            if(isValid && this.tipo.eventos?.length && this.tipo.imagen) {
                this.$emit('terminado');
            }
        }
    },
    watch: {
        "tipo.eventos"(newVal) {
            if (newVal?.length) {
                this.errorEventos = '';
            } else {
                this.errorEventos = 'El obligatorio seleccionar al menos un evento';
            }
        }
    },
    created() {
        this.getEventos();
    },
    components: {
        Dropzone
    }
}
</script>
